import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  n: '1',
  title: 'Instant download',
  desc: 'Purchase and get immediate access to the complete ebook and all 5 bonuses. Start whenever you want, no waiting.'
}, {
  n: '2',
  title: 'Follow the visual method',
  desc: 'Learn joint mechanics, assessment criteria, progression protocols and return-to-sport frameworks in an order designed so you never get lost. The system is your roadmap.'
}, {
  n: '3',
  title: 'Complete the 6-volume system',
  desc: 'Study step by step, apply what you learned with your first client and consolidate your clinical knowledge to manage injuries with real confidence by volume 6.'
}];
export function Steps() {
  return <section aria-label="How it works" className="bg-transparent" data-id="element-165" data-mp="fridpzphj6pr">
      <div className="mx-auto max-w-4xl px-5 py-12" style={{
      paddingTop: "12px",
      paddingBottom: "17px"
    }} data-id="element-166" data-mp="2636hqr7ttg7u">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-167" data-mp="2a2x3uhmer861">
          How You'll Progress Starting Today
        </h2>
        <p className="mt-3 text-center text-sm text-plum/60" data-id="element-168" data-mp="1lcirvx222s4s">In just 3 simple steps</p>

        <ol className="mt-10 space-y-4" data-id="element-169" data-mp="2015iiux4v6bb">
          {steps.map((s, i) => <motion.li key={s.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-start gap-4 rounded-2xl border border-grape/15 bg-white p-5" data-id="element-170" data-mp="200m2jjr1mrzx" data-mpi={i}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-grape font-display text-base font-black text-white" data-id="element-171" data-mp="1haxi4kktityt">
                {s.n}
              </span>
              <div data-id="element-172" data-mp="2sp1efxevou71">
                <h3 className="text-base font-bold text-plum" data-id="element-173" data-mp="2soht06q0rno9">{s.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-174" data-mp="2nrj2dy5kdyut">{s.desc}</p>
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}